/**
 * A soft, abstract face field used when the person hasn't shared photos. It
 * gives the landmark dots something legible to sit on without exposing a real
 * image. Duotone, theme-aware, purely decorative.
 */
export function AbstractFace({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox='0 0 300 200'
      preserveAspectRatio='xMidYMid slice'
      role='img'
      aria-label='Abstract face placeholder'
    >
      <defs>
        <radialGradient id='afSkin' cx='46%' cy='30%' r='80%'>
          <stop offset='0%' stopColor='rgba(255,255,255,0.14)' />
          <stop offset='100%' stopColor='rgba(0,0,0,0.06)' />
        </radialGradient>
      </defs>
      <ellipse
        cx='150'
        cy='104'
        rx='70'
        ry='92'
        fill='url(#afSkin)'
        stroke='rgba(127,127,127,0.18)'
      />
      <path
        d='M120 84 q9 -7 20 0'
        fill='none'
        stroke='rgba(127,127,127,0.35)'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M160 84 q9 -7 20 0'
        fill='none'
        stroke='rgba(127,127,127,0.35)'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M150 100 q-5 16 -8 22 q8 5 16 0'
        fill='none'
        stroke='rgba(127,127,127,0.22)'
        strokeWidth='1.6'
      />
      <path
        d='M136 140 q14 10 28 0'
        fill='none'
        stroke='rgba(127,127,127,0.26)'
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  )
}
